import { BaseViewStore } from 'core/stores';
import { LookupStore } from 'modules/lookup/stores';
import { FulfillmentOrderStore } from 'modules/order/stores';
import { StatusChangeForm } from 'modules/order/forms';
import { observable, action, makeObservable } from 'mobx';
import { lookupRouteName, fulfillmentOrderStatus, sourceOfChange } from 'common/constants';
import { notificationError } from 'core/utils';
import _ from 'lodash';

class StatusChangeViewStore extends BaseViewStore {
	@observable disableSaveBtn = true;
	@observable showReturnOptions = false;
	@observable selectedFulfillmentOrderStatus = null;
	@observable fulfillmentOrderStatusOptions = [];
	selectedItem = null;

	form = new StatusChangeForm({
		onSuccess: this.statusChange,
	});

	constructor(rootStore, { parentViewStore, selectedItemId }) {
		super(rootStore);
		makeObservable(this);
		this.parentView = parentViewStore;
		this.store = new FulfillmentOrderStore(rootStore);
		this.lookupStore = new LookupStore(rootStore);
		this.initialize(selectedItemId);
	}

	@action.bound
	initialize = async selectedItemId => {
		this.form.state.options.set({
			validateOnBlur: false,
			showErrorsOnReset: false,
			validateOnChange: true,
		});
		await this.getFulfillmentOrder(selectedItemId);
		await this.getFulfillmentOrderStatuses();
	};

	@action.bound
	getFulfillmentOrder = async selectedItemId => {
		this.selectedItem = await this.store.getFulfillmentOrder(selectedItemId, { embed: ['fulfillmentOrderStatus'] });
	};

	@action.bound
	getFulfillmentOrderStatuses = async () => {
		await this.lookupStore.find({ page: 1, rpp: 50 }, lookupRouteName.fulfillmentOrderStatus);
		const data = _.filter(this.lookupStore.data, item => {
			if (item.abrv == fulfillmentOrderStatus.returned || item.abrv == fulfillmentOrderStatus.notReceived) {
				return item;
			}
		});
		this.fulfillmentOrderStatusOptions = _.map(data, item => {
			const optionItem = { label: item.name, value: item.id };
			return optionItem;
		});
		this.selectedFulfillmentOrderStatus = {
			label: this.selectedItem.fulfillmentOrderStatus.name,
			value: this.selectedItem.fulfillmentOrderStatusId,
		};
		this.form.$('fulfillmentOrderStatusId').value = this.selectedItem.fulfillmentOrderStatusId;
	};

	@action.bound async statusChange() {
		try {
			const { fulfillmentOrderStatusId } = this.form.values();
			const statusChangeParams = {
				fulfillmentOrderId: this.selectedItem.id,
				fulfillmentOrderStatusId: fulfillmentOrderStatusId,
			};
			await this.store.statusChange(statusChangeParams, sourceOfChange.statusChange);
			this.rootStore.notificationStore.success([
				'STATUSCHANGEVIEW.SUCCESS',
				{ id: this.selectedItem.fulfillmentOrderId },
			]);
			this.parentView.reload = true;
			this.parentView.statusChangeModal.close();
		} catch (err) {
			notificationError({ store: this.rootStore.notificationStore, err });
		}
	}

	onChange = item => {
		this.selectedFulfillmentOrderStatus = item;
		this.form.$('fulfillmentOrderStatusId').value = item.value;
		if (item.value != this.selectedItem.fulfillmentOrderStatusId) {
			this.disableSaveBtn = false;
		} else {
			this.disableSaveBtn = true;
		}
	};
}

export default StatusChangeViewStore;



// WEBPACK FOOTER //
// ./src/modules/order/stores/StatusChangeViewStore.js